import { FormHelperText, TextFieldProps } from '@/primitives';
import { blue, red, slate } from '@/lib/colours';
import {
  DatePicker,
  DatePickerProps,
  PickerValidDate,
} from '@mui/x-date-pickers-pro';

type TOwnProps = DatePickerProps<PickerValidDate> & {
  error?: TextFieldProps['error'];
  helperText?: TextFieldProps['helperText'];
  required?: TextFieldProps['required'];
  variant?: TextFieldProps['variant'];
};

export const DatePickerPro = (props: TOwnProps) => {
  const { variant, required, error, helperText, ...rest } = props;

  const renderError = () => {
    return (
      error &&
      helperText && (
        <FormHelperText error={error} sx={{ marginLeft: '14px' }}>
          {helperText}
        </FormHelperText>
      )
    );
  };

  if (variant === 'filled') {
    return (
      <>
        <DatePicker
          {...rest}
          slotProps={{
            ...props.slotProps,
            textField: {
              ...props.slotProps?.textField,
              error,
              required: props.required,
              variant: props.variant,
              InputLabelProps: {
                shrink: true,
                sx: {
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  lineHeight: '20px',
                  letterSpacing: '0.25px',
                  paddingTop: '3px',
                  paddingLeft: '1px',
                },
              },
              InputProps: {
                disableUnderline: true,
                sx: {
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  border: `1px solid ${slate[300]}`,
                  ':focus-within': {
                    borderColor: blue[600],
                  },
                  ':has(input[aria-invalid="true"])': {
                    borderColor: red[600],
                  },
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '20px',
                  letterSpacing: '0.25px',
                  '.Mui-disabled': {
                    borderRadius: '8px',
                    fontStyle: 'italic',
                  },
                },
              },
            },
          }}
        />
        {renderError()}
      </>
    );
  }

  return (
    <>
      <DatePicker
        {...rest}
        slotProps={{
          textField: {
            required,
            variant,
          },
        }}
      />
      {renderError()}
    </>
  );
};
